import React, { createRef, useState } from "react";
import LcFetch from "lib/shared/fetch";
import { useAccessTier } from "contexts/AccessTierContext";
import Popover from "./Popover";

const LC_EVENT_PAYLOAD = {
  event_name: "In-Content AI Tools popover shown",
  event_type: "popover-shown"
};

const LC_EVENT_COOKIE_NAME = "in_content_ai_tools_popover_shown";

export default function InContentAIToolsPopover() {
  const [isVisible, setIsVisible] = useState(() => {
    return Cookies.get(LC_EVENT_COOKIE_NAME) !== "true";
  });
  const { isSignedOut } = useAccessTier();
  const popoverRef = createRef();

  const onDismiss = async () => {
    if (!isSignedOut) {
      await LcFetch("/lc-events/track", {
        body: JSON.stringify(LC_EVENT_PAYLOAD),
        method: "POST"
      });
    }

    const isSecure = document.location.protocol === "https:";
    Cookies.set(LC_EVENT_COOKIE_NAME, "true", {
      expires: 365,
      secure: isSecure
    });
    setIsVisible(false);
  };

  return (
    <Popover
      ref={popoverRef}
      arrowClass="!tw-right-[14px]"
      arrowX="right"
      containerClass="tw-min-w-[182px] !tw-py-2 !tw-pl-2 !tw-pr-4 !tw-m-0 !tw-top-[26px] !tw-right-[-2px]"
      isVisible={isVisible}
      onDismiss={onDismiss}
      popoverClassName="lc-popover"
    >
      <div className="text tw-flex tw-items-center">
        <i className="lc-icon lc-icon-md lc-icon-sparkles tw-text-blue" />
        <strong className="tw-text-base tw-leading-7">More Tools</strong>
        <span className="subcopy !tw-my-0 !tw-ml-2">New</span>
      </div>
    </Popover>
  );
}
